<template>
  <!-- NOTE (TEMPLATE) to add reason for rejection  -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/admin/rejectionType'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h6>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-reasonList) to show reasons for rejecting proposal list -->
      <b-table
        responsive
        small
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="items"
        empty-text="هنوز طرحی ثبت نشده است"
        striped
        :busy="isBusy"
        :filter="filter"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <div style="text-align: center; vertical-align: middle">
            <b-btn variant="warning" @click="openEdit(data.item)">ویرایش</b-btn>
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
    </b-card>
    <br />
    <b-card
      v-if="$router.currentRoute.path == '/admin/rejectionType'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h4 class="text-primary">افزودن دلیل جدید</h4>
      <hr />
      <b-form-textarea
        trim
        placeholder="متن دلیل جدید"
        rows="6"
        max-rows="6"
        v-model="newReason"
      ></b-form-textarea>

      <!-- NOTE (b-addReason) to add new reason -->
      <b-button
        :disabled="!newReason || submitBusy"
        variant="success"
        @click="addReason()"
        style="float: right"
        class="mt-3"
        >ثبت</b-button
      >
    </b-card>
    <router-view></router-view>
    <b-modal id="edit1" ref="edit1">
      <h4>ویرایش دلیل</h4>
      <br />
      <b-form-group>
        <b-form-input
          trim
          placeholder="متن دلیل"
          v-model="selected.name"
        ></b-form-input>
      </b-form-group>
      <template v-slot:modal-footer>
        <!-- NOTE (b-editRasteh2) previous -->
        <b-button
          :disabled="!selected.name"
          variant="success"
          @click="editReason()"
          >ثبت تغییرات</b-button
        >
      </template>
    </b-modal>
    <b-modal id="delReason" ref="delReason">
      شما در حال حذف این متن از بین الگوهای دلیل رد طرح هستید:
      <br />
      <strong>{{ selectedReason.name }}</strong>
      <br />آیا مطمئن هستید؟
      <template v-slot:modal-footer>
        <!-- NOTE (b-deleteReason2) previous -->
        <b-button variant="danger" @click="doDelReason()" :disabled="submitBusy"
          >بله</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {
      fields: [
        { key: "index", label: "ترتیب" },
        { key: "name", label: "متن دلیل" },
        { key: "operation", label: "عملیات" },
      ],
      items: [],
      filter: "",
      isBusy: true,
      submitBusy: false,
      selectedReason: "",
      newReason: "",
      selected: {},
    };
  },

  methods: {
    getData() {
      // NOTE (m-getData) to get reasons data to show them
      this.isBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/rejections/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/unauthorize",
                query: { return: window.location.pathname },
              });
          }
        });
    },

    addReason() {
      // NOTE (m-addReason) to add new reason
      this.submitBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/rejection/new",
          {
            name: this.newReason,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.submitBusy = false;
          this.newReason = "";
          this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.submitBusy = false;
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/unauthorize",
                query: { return: window.location.pathname },
              });
          }
        });
    },

    openEdit(item) {
      this.selected = item;
      this.$refs["edit1"].show();
    },
    editReason() {
      // NOTE (m-addReason) to add new reason
      this.$http
        .post(
          this.baseUrl + "/setad/admin/rejection/edit",
          {
            rejectionId: this.selected.id,
            name: this.selected.name,
            status: "active",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.getData();
          this.$refs["edit1"].hide();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.submitBusy = false;
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/unauthorize",
                query: { return: window.location.pathname },
              });
          }
        });
    },
  },

  mounted() {
    // NOTE (MOUNTED) to show the reasons data
    this.getData();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
